/** Gaveta de ajuda: aberta de qualquer tela (dica "?", link "Saiba mais"). Estado de módulo, sem provider. */
import { useSyncExternalStore } from "react";

export type HelpTarget = { slug: string; anchor?: string };

let current: HelpTarget | null = null;
const listeners = new Set<() => void>();
const emit = () => listeners.forEach((l) => l());

/** Abre a gaveta no artigo (e na seção) — "dns#cloudflare" ou ("dns", "cloudflare"). */
export function openHelp(slugOrDoc: string, anchor?: string) {
  const [slug, hash] = slugOrDoc.split("#");
  current = { slug: slug!, anchor: anchor ?? hash };
  emit();
}
export function closeHelp() {
  current = null;
  emit();
}
export function useHelpTarget(): HelpTarget | null {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => current,
    () => null,
  );
}
